import { Directive } from '@angular/core';

@Directive({
  selector: '[nttNavItemIcon]',
  host: {
    class: 'ntt-nav-item__icon',
  },
})
export class NttNavItemIcon {}
